import React from 'react';

const LinksRenderer = (props) => {
    const { value } = props; // value is expected to be an array
    const getId = (item: string): string  => {
        return item.slice(0, -1).split('/').pop()
    }

    return (
        <div>
            {value && Array.isArray(value) && value.map((item, index) => (
                <span>
                    <a key={index} href={`https://bazaart.com/category/${getId(item)}/slug`} target="_blank" rel="noopener noreferrer">
                        { getId(item) }
                    </a>
                    <span> </span>
                </span>
            ))} 

            { value && !Array.isArray(value) ?
                <span>
                    <a key={value} href={`https://staging.design.bazaart.com/design/${value}/edit`} target="_blank" rel="noopener noreferrer">
                        { value }
                    </a>
                    <span> </span>
                </span>
            : ''} 
        </div>
    );
};

export default LinksRenderer;
